(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-banner"] && !Shopify.designMode) return;
  try {
    
(function() {
  try {
    var containers = document.querySelectorAll('.video-container .video-link');
    containers.forEach(function(link) {
      var video = link.querySelector('video');
      if (!video) return;

      video.addEventListener('click', function(event) {
        if (video.hasAttribute('controls')) {
          return;
        }
        var href = link.getAttribute('href');
        if (href) {
          window.location.href = href;
        }
      });
    });
  } catch (e) {
    console.error(e);
  }
})();

  } catch(e) { console.error(e); }
})();
})();
